// web/src/app/supabaseClient.ts
//
// Singleton Supabase client for the web app. Hard-fails on missing env —
// RTLS playback is database-only (no JSON fallback). If VITE_SUPABASE_URL or
// VITE_SUPABASE_ANON_KEY is missing, module initialization throws.
//
// This module is the ONLY place that reads VITE_* env vars for Supabase.

import { createRTLSClient, type RTLSSupabaseClient } from '@shared/supabase/client'

const url     = import.meta.env.VITE_SUPABASE_URL      as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

if (!url || !anonKey) {
  throw new Error(
    '[RTLS] Missing Supabase env vars: ' +
    'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required. ' +
    'Add them to web/.env.local to run the app.',
  )
}

// Enable session persistence so login state survives reloads. Web uses
// localStorage by default — no extra storage argument needed.
export const supabase: RTLSSupabaseClient = createRTLSClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
})

if (import.meta.env.DEV) {
  console.log('[RTLS] Supabase client ready.')
}
